import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, signInWithPhoneNumber, RecaptchaVerifier } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBF-GSsnayoyAfRhX29TnCErXD4N4pT3pk",
  authDomain: "butterflies-c1d94.firebaseapp.com",
  projectId: "butterflies-c1d94",
  storageBucket: "butterflies-c1d94.appspot.com",
  messagingSenderId: "316561291107",
  appId: "1:316561291107:web:339b5ea3341d774f3a0556",
  measurementId: "G-JZZX7J7C73"
};

// Log the config for debugging
console.log('Firebase Config:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  apiKey: firebaseConfig.apiKey ? '***' + firebaseConfig.apiKey.slice(-4) : 'undefined'
});

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log('Firebase app initialized:', app.name);

const analytics = getAnalytics(app);
console.log('Firebase analytics initialized');

const auth = getAuth(app);
console.log('Firebase auth initialized:', auth.app.name);

const googleProvider = new GoogleAuthProvider();
console.log('Google provider created');

// Configure Google provider
googleProvider.setCustomParameters({
  prompt: 'select_account',
  access_type: 'offline'
});

// Add scopes if needed
googleProvider.addScope('email');
googleProvider.addScope('profile');

console.log('Google provider configured with email and profile scopes');

export { app, analytics, auth, googleProvider, signInWithPopup, signInWithRedirect, getRedirectResult, signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut, onAuthStateChanged, signInWithPhoneNumber, RecaptchaVerifier }; 